module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-50.d51d5ee9.svg";